import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DownloadSimple, IconContext, MoneyWavy, Ticket } from '@phosphor-icons/react';
import { Button , InfoCard } from 'app/components';
import { getEventDashboard } from '../../api';

const ReportCard = (props) => {
  const {
    icon,
    label,
    value,
    valueSuffix,
    note,
  } = props;

  return (
    <div className="p-6 flex flex-col gap-6 shadow-xs border rounded-lg border-solid border-grey-200">
      {icon && (
        <IconContext.Provider
          value={{
            color: '#FF2459',
            size: 32,
          }}
        >
          <div className="p-6 bg-light w-fit h-fit rounded-lg">
            {icon}
          </div>
        </IconContext.Provider>
      )}
      <div className="flex flex-col gap-3 text-black">
        <div className="heading-16">{label}</div>
        <div className="flex gap-3 items-baseline">
          <div className="heading-36">{value}</div>
          <div className="label-16">{valueSuffix}</div>
        </div>
        {note && <div className="label-14 italic">Subject to platform fees & tax deductions</div>}
        {note && <InfoCard content={note}/>}
      </div>
    </div>
  );
};

const Dashboard = ({ stateName }) => {
  const params = useParams();
  const { eventDetails } = useSelector((state) => state[stateName || 'eventDashboard']);
  const { dashboard } = useSelector((state) => state.eventDashboard);

  useEffect(() => {
    if (params?.eventId) getEventDashboard(params.eventId);
  }, [params?.eventId]);

  const ticketsDetails = useMemo(() => {
    if (dashboard?.tickets_category?.length) {
      const config = {};
      dashboard?.tickets_category?.forEach((ticket) => {
        config[ticket?.ticket_id] = ticket;
      });

      return config;
    }

    return {};
  }, [dashboard?.tickets_category]);

  if (window.innerWidth <= 768) {
    return (
      <div className="px-6 py-6 flex-1">
        <div className="flex justify-between pb-6">
          <div className="heading-20">Report Dashboard</div>
          {/* <Button
            type="tertiary"
            iconLeft={<DownloadSimple />}
          >
            Export report as CSV
          </Button> */}
        </div>
        <div className="grid grid-cols-1 gap-6">
          <ReportCard
            label="Customer Payments Received"
            value={`₹ ${dashboard?.total_revenue ?? 0}`}
            icon={<MoneyWavy />}
            note="This amount includes platform fees, payment gateway charges & taxes collected from customers. Your actual payout will be calculated from base ticket prices after deductions."
          />
          <ReportCard
            label="Total tickets sold"
            value={`${dashboard?.tickets_sold ?? 0}`}
            icon={<Ticket />}
          />
        </div>
        <div className="horizontal-divider my-6" />
        <div className="flex flex-col gap-6">
          <div className="heading-16">Category wise sales</div>
          <div className="grid grid-cols-1 gap-6">
            {eventDetails?.smp_detail_entity_set?.map((ticketConfig) => (
              <ReportCard
                key={ticketConfig?.id}
                label={ticketConfig?.option_value_1}
                value={`${(ticketsDetails[ticketConfig?.id]?.total_count || 0) - (ticketsDetails[ticketConfig?.id]?.available_count || 0)}`}
                valueSuffix={`out of ${ticketsDetails[ticketConfig?.id]?.total_count ?? 0}`}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="px-14 py-9 flex-1">
      <div className="flex justify-between pb-9">
        <div className="heading-24">Report Dashboard</div>
        {/* <Button
          type="tertiary"
          iconLeft={<DownloadSimple />}
        >
          Export report as CSV
        </Button> */}
      </div>
      <div className="grid grid-cols-2 gap-9">
        <ReportCard
          label="Customer Payments Received"
          value={`₹ ${dashboard?.total_revenue ?? 0}`}
          icon={<MoneyWavy />}
          note="This amount includes platform fees, payment gateway charges & taxes collected from customers. Your actual payout will be calculated from base ticket prices after deductions."
        />
        <ReportCard
          label="Total tickets sold"
          value={`${dashboard?.tickets_sold ?? 0}`}
          icon={<Ticket />}
        />
      </div>
      <div className="horizontal-divider my-9" />
      <div className="flex flex-col gap-6">
        <div className="heading-16">Category wise sales</div>
        <div className="grid grid-cols-3 gap-6">
          {eventDetails?.smp_detail_entity_set?.map((ticketConfig) => (
            <ReportCard
              key={ticketConfig?.id}
              label={ticketConfig?.option_value_1}
              value={`${(ticketsDetails[ticketConfig?.id]?.total_count || 0) - (ticketsDetails[ticketConfig?.id]?.available_count || 0)}`}
              valueSuffix={`out of ${ticketsDetails[ticketConfig?.id]?.total_count ?? 0}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
